import { useTranslation } from '../../hooks/useTranslation'
import { paymentErrorText } from '../../lib/paymentError'
import Moment, { MomentHeadline, MomentIcon, MomentText } from './Moment'

/** Calm, not alarming: what happened in plain words, what to do, and the
 *  terminal's code small underneath for the cashier. */
export default function ErrorMoment({ message }: { message: string }) {
  const { t } = useTranslation()

  return (
    <Moment>
      <div className="motion-safe:animate-shake">
        <MomentIcon tone="danger">✕</MomentIcon>
      </div>
      <MomentHeadline tone="danger">{t('payment-error-headline')}</MomentHeadline>
      <MomentText>{paymentErrorText(message, t)}</MomentText>
      <div className="mt-cfd-3 rounded-full bg-bg px-[1em] py-[0.35em] font-mono text-cfd-label tracking-[0.08em] text-text-mid">
        {message}
      </div>
    </Moment>
  )
}
